<script>
import { authComputed } from '@state/helpers'

export default {
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <v-flex xs5 class="sidebar pa-5">
    <v-layout column fill-height justify-space-between>
      <div>
        <BaseLink name="login"><img src="/assets/logo-medcomm.svg" class="logo" alt="Logo" /></BaseLink>
      </div>
      <h2>
        Customized Charge Cycle Solutions that reduce denials, enhance
        revenue, and sustain results.
      </h2>
    </v-layout>
  </v-flex>
</template>

<style lang="scss">
@import '@design';

.sidebar {
  background: url('/assets/bg-login.png') no-repeat center center;
  background-size: cover;
  * {
    color: white;
  }
}
</style>
